import { BroadcastedValue, BroadcastState } from '~/types';
import { useBroadcastedValue } from '~/useBroadcastedValue';
import { useBroadcastState } from '~/useBroadcastState';

export type SelectSignalsEvent = {
  channel: 'signals';
  type: 'select-signals';
  payload: Record<string, boolean>;
};

export const useSelectSignalsBroadcastedValue: BroadcastedValue<SelectSignalsEvent> = ({
  initialValue,
} = {}) => {
  return useBroadcastedValue({
    channel: 'signals',
    event: 'select-signals',
    initialValue,
  });
};

export const useSelectSignalsBroadcastState: BroadcastState<SelectSignalsEvent> = ({
  initialValue,
} = {}) => {
  return useBroadcastState({
    channel: 'signals',
    event: 'select-signals',
    initialValue,
  });
};
